import _ from 'lodash'
import { getAllAccountFromLocalStorage } from '../utils/helpers'
import useAccounts, { UseAccountOptions } from './useAccounts'
import useDebounce from './useDebounce'
import useOrganizationsById from './useOrganizationsById'

const useAccountsWithOrgs = (searchText: string, options: UseAccountOptions = {}, debounceMs?: number) => {
  const debouncedSearchText = useDebounce(searchText, debounceMs)
  const { loading: loadingAccs, error: errorAccs, data: dataAccs } = useAccounts(debouncedSearchText, options)

  const orgIds: number[] = (dataAccs?.accounts || []).map(account => account.orgid)
  const orgOptions = {
    limit: orgIds.length,
    adminListing: !!options.adminListing,
  }
  const { loading: loadingOrgs, error: errorOrgs, data: dataOrgs } = useOrganizationsById(orgIds, orgOptions)
  if (dataAccs?.accounts?.length > 0) {
    const organizations = _.keyBy(dataOrgs?.organizations || [], 'orgId')
    dataAccs.accounts.forEach(account => {
      if (_.isNumber(account.orgid) && _.has(organizations, account.orgid)) {
        account.organization = organizations[account.orgid]
      }
    })
  }

  const lastAccessed = getAllAccountFromLocalStorage()

  if (dataAccs && dataAccs?.accounts) {
    dataAccs.accounts = dataAccs.accounts.map((account) => ({ ...account, lastAccessed: lastAccessed[account.id] }))
  }

  return {
    loading: loadingAccs || loadingOrgs,
    loadingAccounts: loadingAccs,
    error: errorAccs || errorOrgs,
    data: dataAccs || [],
  }
}

export default useAccountsWithOrgs
